import { LoginProvider } from "src/enums";

const providerToApi = {
  [LoginProvider.APPLE]: "apple",
  [LoginProvider.GOOGLE]: "google",
  [LoginProvider.TANGO_PHONE_NUMBER]: "phone",
};

export default providerToApi;
